import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'

const apiBase = (process.env.VUE_APP_API_BASE || '/api').replace(/\/$/, '')
const http = axios.create({ baseURL: apiBase, timeout: 30000 })

function apiMessage(err) {
  const data = err.response?.data
  const serverMessage = data && typeof data === 'object' ? data.message : ''
  if (typeof serverMessage === 'string' && serverMessage && !serverMessage.startsWith('<')) return serverMessage
  const status = err.response?.status
  if (!err.response || status === 502 || status === 503 || status === 504) return '服务暂时不可用，请稍后再试'
  if (status === 401) return '请先登录'
  return '操作失败'
}

let lastNotice = ''
let lastNoticeAt = 0
function notify(message) {
  const now = Date.now()
  if (message === lastNotice && now - lastNoticeAt < 1500) return
  lastNotice = message
  lastNoticeAt = now
  // 顺丰等长错误用弹窗，方便看官方码/原始返回
  if (typeof message === 'string' && (message.length > 80 || message.includes('官方') || message.includes('原始返回') || message.startsWith('顺丰'))) {
    ElMessageBox.alert(message, '接口返回', {
      confirmButtonText: '知道了',
      customClass: 'api-error-box'
    }).catch(() => {})
    return
  }
  ElMessage.error(message)
}

function isApiFailure(error) {
  return !!(error && (error.isApiError || error.isAxiosError))
}

if (typeof window !== 'undefined') {
  const stopOverlay = (event) => {
    const error = event.reason || event.error
    if (!isApiFailure(error)) return
    event.preventDefault()
    event.stopImmediatePropagation()
  }
  window.addEventListener('unhandledrejection', stopOverlay, true)
  window.addEventListener('error', stopOverlay, true)
}

http.interceptors.request.use(config => {
  const token = localStorage.getItem('xk_token')
  const factoryId = localStorage.getItem('xk_factory')
  if (token) config.headers.Authorization = 'Bearer ' + token
  if (factoryId) config.headers['X-Factory-Id'] = factoryId
  return config
})

http.interceptors.response.use(res => {
  if (res.config.responseType === 'blob') return res
  const body = res.data
  if (body && body.code !== 0) {
    const message = body.message || '操作失败'
    notify(message)
    const error = new Error(message)
    error.isApiError = true
    return Promise.reject(error)
  }
  return body.data
}, err => {
  err.isApiError = true
  if (err.response?.status === 401) {
    localStorage.removeItem('xk_token')
    if (location.pathname !== '/login') location.href = '/login'
  }
  notify(apiMessage(err))
  return Promise.reject(err)
})

export function download(url, params, filename) {
  return http.get(url, { params, responseType: 'blob' }).then(res => {
    const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8' })
    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob)
    a.download = filename
    a.click()
    URL.revokeObjectURL(a.href)
  })
}

export default http
